webpackJsonp([169691563564829],{

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookActions = __webpack_require__(26);
	
	var _LoreHookActions2 = _interopRequireDefault(_LoreHookActions);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookActions2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Default Config'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default configuration is shown below.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import create from \'./blueprints/create\';\n      import destroy from \'./blueprints/destroy\';\n      import get from \'./blueprints/get\';\n      import find from \'./blueprints/find\';\n      import refetch from \'./blueprints/refetch\';\n      import update from \'./blueprints/update\';\n\n      export default {\n        normalize: true,\n        addCidToBody: false,\n        cidBodyAttributeName: \'cid\',\n        blueprints: {\n          create,\n          destroy,\n          get,\n          find,\n          refetch,\n          update\n        }\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-actions-config-index-js-b2f5eff8971f619d6c7c.js